export default __webpack_public_path__ + "assets/safari-ios.8b67dfb88ecd45ff1cc315145424b368.png";